import { messageColors } from './consts';
const baseStyle = {};
const defaultProps = {
    variant: 'info',
    size: 'lg'
};
const sizes = {
    sm: {
        fontSize: 'xs'
    },
    md: {
        fontSize: 'sm'
    },
    lg: {
        fontSize: 'md'
    },
    xl: {
        fontSize: 'lg'
    }
};
const variants = {
    info: {
        color: messageColors.info
    },
    warning: {
        color: messageColors.warning
    },
    error: {
        color: messageColors.error
    },
    success: {
        color: messageColors.success
    }
};
export default {
    baseStyle,
    defaultProps,
    sizes,
    variants
};
